import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import { useGetStatementOnlineLogQuery,useLazyGetStatementOnlineQuery } from '../../services/statementOnline';
import SearchLogStatement from '../../components/Search/SearchLogStatement';
import TableLogStatementOnline from '../../components/TableStatmentOnline/TableLogStatementOnline';
import { checkAccessRights } from '../../utils/functions/accessRight';
import { ROLES } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';

dayjs.extend(utc);

const formatStatementDateTime = (value) =>
  value ? dayjs.utc(value).add(7, 'hour').format('YYYY-MM-DD HH:mm:ss.SSS') : '';

function LogStatement() {
  const { value: merchant, allMerchant } = useSelector(
    (state) => state.merchant,
  );
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('transaction_date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [fetchAllStatement] = useLazyGetStatementOnlineQuery();
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [totalIsExact, setTotalIsExact] = useState(false);
  const [statementLogValue, setStatementLogValue] = useState([]);

  const [statusItems, setStatusItems] = useState([
    { label: 'Match', value: 'match' },
    { label: 'Unmatch', value: 'unmatch' },
    { label: 'Partial', value: 'partial' },
  ]);
  const [detailStatusItems, setDetailStatusItems] = useState([
    { label: 'Manual', value: 'Manaul', disable: false },
    { label: 'Booking', disable: false },
    { label: 'Suspense', disable: false },
    { label: 'Suspense - AR', disable: false },
    { label: 'Partial Suspense', disable: false },
    { label: 'เงินรับ JV', disable: false },
    { label: 'เงินยืม JV', disable: false },
    { label: 'โยกเงิน', disable: false },
    { label: 'ดึงเงินระหว่างบัญชี', disable: false },
    { label: 'เช็คเด้ง-โอนเด้ง', disable: false },
    { label: 'เงินรับ OPS', disable: false },
    { label: 'รายได้อื่น - HR', disable: false },
    { label: 'รายได้อื่น - TAX', disable: false },
    { label: 'รายได้อื่น - BANK', disable: false },
    { label: 'รายได้อื่น - REIT', disable: false },
    { label: 'รายได้อื่น - เงินกู้', disable: false },
    { label: 'รายได้อื่น - Factoring', disable: false },
    { label: 'รายได้อื่น - เงินลงทุน', disable: false },
    { label: 'รายได้อื่น - ค่าปรับพนักงาน', disable: false },
    { label: 'รายได้อื่น - Other', disable: false },
    { label: 'เงินจ่าย OPS', disable: false },
    { label: 'รายจ่ายอื่น - BANK', disable: false },
    { label: 'รายจ่ายอื่น - เงินกู้', disable: false },
    { label: 'รายจ่ายอื่น - Factoring', disable: false },
    { label: 'รายจ่ายอื่น - เงินลงทุนอื่น', disable: false },
    { label: 'รายจ่ายอื่น - ค่าธรรมเนียม', disable: false },
  ]);
  const [formDefaultData, setFormDefaultData] = useState({
    bank: '',
    accountNo: '',
    status: '',
    detailStatus: '',
    startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    startEffectiveDate: '',
    endEffectiveDate: '',
    creditAmount: '',
    debitAmount: '',
    search: '',
  });

  const isAdminRole = checkAccessRights(ROLES.ADMIN_ROLE);
  const isSuperAdminRole = checkAccessRights(ROLES.SUPER_ADMIN_ROLE);
  const sorgcode = isAdminRole ? merchant || '' : allMerchant || '';
  const shouldSkip =
    (isAdminRole && !merchant) || (isSuperAdminRole && !allMerchant);
  const { t } = useTranslation();
    const [isExporting, setIsExporting] = useState(false);


  const {
    data: getList,
    isLoading,
    isFetching,
  } = useGetStatementOnlineLogQuery(
    {
      bank: formDefaultData.bank || '',
      accountNo: formDefaultData.accountNo || '',
      status: formDefaultData.status || '',
      detailStatus: formDefaultData.detailStatus || '',
      startDate: formDefaultData.startDate
        ? dayjs(formDefaultData?.startDate).format('YYYY-MM-DD')
        : dayjs().startOf('month').format('YYYY-MM-DD'),
      endDate: formDefaultData.endDate
        ? dayjs(formDefaultData?.endDate).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD'),
      startEffectiveDate: formDefaultData.startEffectiveDate
        ? dayjs(formDefaultData?.startEffectiveDate).format('YYYY-MM-DD')
        : '',
      endEffectiveDate: formDefaultData.startEffectiveDate
        ? dayjs(formDefaultData?.endEffectiveDate).format('YYYY-MM-DD')
        : '',
      creditAmount: formDefaultData.creditAmount || NaN,
      debitAmount: formDefaultData.debitAmount || NaN,
      search: formDefaultData.search || '',
      sorgcode,
      size: rowsPerPage,
      page: page + 1,
      sortBy,
      sortOrder,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: shouldSkip,
    },
  );

  const handleExportExcel = async () => {
      try {
        setIsExporting(true);
  
        // ✅ 3. ใช้ Lazy Query แทน fetch เพื่อดึงข้อมูลทั้งหมด
        const response = await fetchAllStatement({
          bank: formDefaultData.bank || '',
          accountNo: formDefaultData.accountNo || '',
          status: formDefaultData.status || '',
          detailStatus: formDefaultData.detailStatus || '',
          startDate: formDefaultData.startDate
            ? dayjs(formDefaultData?.startDate).format('YYYY-MM-DD')
            : dayjs().startOf('month').format('YYYY-MM-DD'),
          endDate: formDefaultData.endDate
            ? dayjs(formDefaultData?.endDate).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD'),
          startEffectiveDate: formDefaultData.startEffectiveDate
            ? dayjs(formDefaultData?.startEffectiveDate).format('YYYY-MM-DD')
            : '',
          endEffectiveDate: formDefaultData.endEffectiveDate
            ? dayjs(formDefaultData?.endEffectiveDate).format('YYYY-MM-DD')
            : '',
          creditAmount: formDefaultData.creditAmount || NaN,
          debitAmount: formDefaultData.debitAmount || NaN,
          search: formDefaultData.search || '',
          sorgcode,
          size: 999999, // 🎯 ทริค: ใส่ size เยอะๆ เพื่อให้ได้ข้อมูลครบทุกหน้าในครั้งเดียว
          page: 1,      // 🎯 เริ่มดึงที่หน้า 1 เสมอ
        }).unwrap(); // ใช้ .unwrap() เพื่อให้จับ Error ได้ง่ายขึ้น
  
        // ข้อมูลที่ได้มาจะอยู่ในรูปแบบเดียวกับที่ตารางใช้
        const allData = response?.data || response; 
  
        if (!allData || allData.length === 0) {
          alert(t('app.noDataAvailable'));
          setIsExporting(false);
          return;
        }
  
        // 4. จัดเตรียมข้อมูลลง Excel (โค้ดส่วนนี้ของคุณถูกต้องแล้ว)
        const exportData = allData.map((item) => ({
          [t('app.statementRef')]: item.statement_ref || '',
          [t('app.bookbankNo')]: item.bookbank || '',
          [t('app.dateTime')]: formatStatementDateTime(item.transaction_date),
          [t('app.effectiveStartDate')]: formatStatementDateTime(item.effective_date),
          [t('app.actualReceived')]: item.amount || 0,
          [t('app.actualPaid')]: item.debit_amount || 0,
          [t('app.amountUsed')]: item.new_spend_amount || 0,
          [t('app.balance')]: item.new_balance || 0,
          [t('app.broughtForward')]: item.balance || 0,
          [t('app.status')]: item.status || '',
          [t('app.detailStatus')]: item.detail_status || '',
          [t('app.remark')]: item.remark || '',
          [t('app.description')]: item.description || '',
          [t('app.channel')]: item.channel || '',
          [t('navbar.custNo')]: item.customer_code || '',
          [t('navbar.custName')]: item.customer_name || '',
          [t('app.invoiceNo')]: item.invoice_no || '',
          [t('app.bsNo')]: item.bs_no || '',
          [t('app.rc03')]: item.RC03 || '',
          [t('app.chqNo')]: item.check_no || '',
          [t('app.updateBy')]: item.edit_by || '',
        }));
  
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'LogStatement_Online');
  
        const fileName = `LogStatement_All_${dayjs().format('YYYYMMDD_HHmmss')}.xlsx`;
        XLSX.writeFile(workbook, fileName);
  
      } catch (error) {
        console.error('Export Excel Error:', error);
        alert('เกิดข้อผิดพลาดในการดึงข้อมูลสำหรับ Export');
      } finally {
        setIsExporting(false); 
      }
    };
  useEffect(() => {
    if (getList) {
      const { pagination, data: rows } = getList;
      setTotal(pagination.total);
      setHasMore(Boolean(pagination.hasMore));
      setTotalIsExact(Boolean(pagination.totalIsExact));
      setStatementLogValue(rows);
      // setStatementValue(rows);
      // console.log('rows', Test);
    }
    return () => {};
  }, [getList]);

  useEffect(() => {}, [merchant]);

  const searchData = (nextFilterData) => {
    setPage(0);
    setFormDefaultData(nextFilterData);
  };
  


  return (
    <div className="mx-auto">
      <div className="my-2 ml-2">
        <div className="text-lg font-light flex flex-wrap items-center justify-between">
          <div className="lg:w-3/4 w-1/2 font-bold">{t('app.logStatement')}</div>
        </div>
      </div>
      <SearchLogStatement
      t={t}
        statusItems={statusItems}
        detailStatusItems={detailStatusItems}
        formDefaultData={formDefaultData}
        setFormDefaultData={setFormDefaultData}
        callApiGetStatementOnline={searchData}
        merchant={merchant}
        setPage={setPage}
        onExportExcel={handleExportExcel} // ✅ ส่งฟังก์ชันไปให้ปุ่ม
        isExporting={isExporting} // ✅ ส่งสถานะโหลดไปบอกปุ่ม
        isSearching={shouldSkip || isFetching}
      />
      <TableLogStatementOnline
      t={t}
        isFetching={isFetching}
        page={page}
        setPage={setPage}
        total={total}
        hasMore={hasMore}
        totalIsExact={totalIsExact}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        statementLogValue={statementLogValue}
        sortBy={sortBy}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
      />
    </div>
  );
}

export default LogStatement;
